import { Grid, Typography, Box, Tabs, Tab, Card } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { capitalCase } from 'change-case';
import Image from 'components/Image';
import Reward from 'assets/images/rewards.svg';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import Page from 'components/Page';
import usePortalId from 'hooks/portal/usePortalId';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  POINTS_AND_REWARDS_NAVIGATION,
  PATH_USER,
  POINTSANDREWARD,
} from 'routes/paths';
import useResponsive from 'hooks/useResponsive';
import RewardForm from '../child/form/RewardForm';
import { useWooCommerceStores } from 'api/ApiHooks/PointsRewardsApiHooks';
import PartialPageSpinner from 'components/PartialPageSpinner';
import AddStore from '../AddStore/AddStore';
import useIfValidityExpired from 'hooks/apps/useIfValidityExpired';
import Notices from 'containers/common/Notices/Notices';

export default function CreateCoupon() {
  useIfValidityExpired(POINTSANDREWARD);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const portalId = usePortalId();
  const smUp = useResponsive('up', 'sm');
  const { data } = useWooCommerceStores(Number(portalId), POINTSANDREWARD);
  if (data === undefined) {
    return <PartialPageSpinner />;
  }

  return (
    <Page title={t('rewards')} className='px-6'>
      <Grid container spacing={1}>
        <Grid item xs='auto'>
          <Image
            sx={{
              width: '36px',
              height: '36px',
              display: 'inline-block',
            }}
            visibleByDefault
            disabledEffect
            src={Reward}
            alt={t('points_and_rewards')}
          />
        </Grid>
        <Grid item xs={4}>
          <Typography variant='h4' gutterBottom>
            {t('points_and_rewards')}
          </Typography>
        </Grid>
        <Grid item xs={smUp ? 7 : 6}>
          <LoadingButton
            sx={{ verticalAlign: 'text-bottom', float: 'right' }}
            variant='contained'
            loading={false}
            onClick={() =>
              navigate(PATH_USER.general.accountSettings(portalId, 'billing'))
            }
          >
            {t('manage_app')}
          </LoadingButton>
        </Grid>
      </Grid>
      <HeaderBreadcrumbs
        heading={t('')}
        links={[
          {
            name: t('all_apps'),
            href: PATH_USER.appListing(portalId),
          },
          {
            name: t('points_and_rewards'),
            href: '',
          },
          {
            name: capitalCase(t('create_new_rewards')),
            href: '',
          },
        ]}
      />
      <Notices appName={POINTSANDREWARD} />
      <Box sx={{ mb: 5 }} />
      <Tabs
        allowScrollButtonsMobile
        variant='scrollable'
        scrollButtons='auto'
        value='rewards'
        onChange={(e, tabIndex) =>
          navigate(
            POINTS_AND_REWARDS_NAVIGATION.general.pointsRewardsListingTabLinks(
              portalId,
              tabIndex
            )
          )
        }
      >
        <Tab
          disableRipple
          key={t('rewards')}
          label={capitalCase(t('create_new_rewards'))}
          icon=''
          value='rewards'
        />
      </Tabs>

      <div className='flex flex-wrap gap-[10%] sm:flex-nowrap'>
        <div className='flex-grow py-5'>
          {data.data.isConnected ? (
            <RewardForm type='add' storeId={data.data._id} />
          ) : (
            <AddStore />
          )}
        </div>
        <div className='sm:basis-3/6'></div>
      </div>
    </Page>
  );
}
